import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

const InformationalOperationTableHeader: FC = () => {
  const { t } = useTranslate();

  return (
    <thead>
      <tr className="nk-tb-item tb-tnx-head">
        <th className="nk-tb-col text-left">{t('Participants')}</th>
      </tr>
    </thead>
  );
};

export default InformationalOperationTableHeader;
